// extracted by mini-css-extract-plugin
export var hidden = "_4l-1";
export var leftPanel = "_4l-2";
export var readonlyInspector = "_4l-3";
export var rightPanel = "_4l-0";